import ExceptionService from '../ExceptionService.js'

export default class ConfigUtil {
  constructor() {
    this.logging = new ExceptionService()
  }


  retrieveConfiguration() {
    return fetch('./config/config.json', {cache: 'reload'})
      .then(res => res.json())
  }
}
